import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m))
}